import {
  Box,
  Stack,
  useTheme
} from '@mui/material';
import {
  InsufficientAccessBackground,
  TaskHeaderSection,
  TaskTable,
  useAccessState
} from 'modules';



export type TasksActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const TasksActivity = (props: TasksActivityProps) => {
  const theme = useTheme();
  const access = useAccessState('Task');

  return access.view
    ? (
      <Stack
        sx={{
          background: 'linear-gradient(0deg, rgba(2, 0, 67, 0.00) 72.6%, rgba(2, 0, 67, 0.02) 99.87%), var(--Supporting-white, #FFF)'
        }}
        justifyContent='stretch'
        alignItems='stretch'
        borderRadius='1.5rem'
        border='6px solid white'
        direction='column'
        paddingX='2rem'
        paddingY='2rem'
        rowGap='1.5rem'
      >
        {/* HEADER */}
        <TaskHeaderSection.FC />
        {/* PAGE CONTENT */}
        <Box
          borderRadius='.75rem'
          paddingX='.875rem'
          bgcolor={theme.palette.customGray.light}
        >
          <TaskTable.FC />
        </Box>

      </Stack>
    )
    : (
      <InsufficientAccessBackground.FC />
    );
};
